/* ducks-n-stuff — the shop's filter rail.
   The form is a plain GET, so filtering works with JavaScript off. All this
   does is submit it when a control changes, and drop empty fields so the URL
   stays tidy. */
(function () {
  function tidyAndSubmit(form) {
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      if (input.value === '') input.disabled = true;
    });
    form.submit();
  }

  document.querySelectorAll('[data-dns-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      tidyAndSubmit(form);
    });

    form.addEventListener('submit', function () {
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        if (input.value === '') input.disabled = true;
      });
    });
  });

  // The sort select lives outside the form and is wired to it with `form=`.
  document.querySelectorAll('[data-dns-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.form;
      if (form) tidyAndSubmit(form);
    });
  });

  // On phones the rail sits above the grid, so it starts collapsed. With no
  // JavaScript it simply stays open, which is the safe default.
  var MOBILE = window.matchMedia('(max-width: 899px)');

  function applyCollapse() {
    document.querySelectorAll('[data-dns-filter-body]').forEach(function (body) {
      var head = body.parentElement.querySelector('[data-dns-filter-toggle]');
      if (!head) return;
      if (MOBILE.matches) {
        if (!head.hasAttribute('data-bound')) {
          head.setAttribute('data-bound', '');
          head.setAttribute('role', 'button');
          head.setAttribute('tabindex', '0');
          head.addEventListener('click', function (event) {
            if (event.target.closest('.dns-shop__clear')) return;
            var open = body.hasAttribute('hidden');
            if (open) { body.removeAttribute('hidden'); } else { body.setAttribute('hidden', ''); }
            head.setAttribute('aria-expanded', String(open));
          });
          head.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); head.click(); }
          });
        }
        // keep it open if the shopper already has a filter applied
        var active = body.querySelector('input:checked, input[type="number"][value]');
        if (!active) { body.setAttribute('hidden', ''); head.setAttribute('aria-expanded', 'false'); }
      } else {
        body.removeAttribute('hidden');
        head.removeAttribute('aria-expanded');
      }
    });
  }

  applyCollapse();
  MOBILE.addEventListener('change', applyCollapse);
})();